import styled from 'styled-components'

import { cssTypes, gridTypes } from '../types'
import { css, grid } from '../util'

/**
 * @namespace GridCell
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const GridCell = styled.div`
  ${css};
  ${grid};
`

/**
 * @name defaultProps
 * @memberof GridCell
 * @desc Primitive's default properties
 */
GridCell.defaultProps = {
  column: 'auto',
  row: 'auto',
}

/**
 * @name propTypes
 * @memberof GridCell
 * @desc Primitive's prop type definitions
 */
GridCell.propTypes = {
  ...cssTypes,
  ...gridTypes,
}

/** @component */
export default GridCell
